<template>
    <div class="flex flex-row items-center" tabindex="0">
        <!-- @blur="closeDropdown" -->
        <div class="flex flex-grow relative">
            <div class="flex justify-between  w-full relative">
                <svg  class="absolute z-[99] left-[16px] top-[17px]" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 15L10.3333 10.3333M11.8889 6.44444C11.8889 9.45133 9.45133 11.8889 6.44444 11.8889C3.43756 11.8889 1 9.45133 1 6.44444C1 3.43756 3.43756 1 6.44444 1C9.45133 1 11.8889 3.43756 11.8889 6.44444Z" stroke="white" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
                </svg>
                <input :disabled="disabled" @focus="openDropDown" :value="searchString" @keyup="changeSearchProduct" type="text" class="rounded w-full relative pl-10 h-[50px] bg-transparent align-top border-[#464851] border-2" placeholder="Search Product by SKU, Name, GTIN within PO">
                <!-- @blur="closeDropdown" -->
                <svg v-if="searchString" @click="resetSearch" class="cursor-pointer absolute right-[10px] top-[17px]" width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z" fill="white"/>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
export default defineComponent({
    props: ['searchString'],
    methods: {
        resetSearch(){
            this.$emit('changeSearchProduct', '')
        },
        changeSearchProduct(e){
            this.$emit('changeSearchProduct',e.target.value)
        }
    }
})
</script>